


























































import { Component, Vue, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import TetrisMenu from '../TetrisMenu'
import { Block, Color, Stat, State } from '../../types'

const progress = namespace('progress')

@Component({
  name: 'Tetris',
  components: { TetrisMenu },
})
export default class Tetris extends Vue {
  @progress.Getter getProgress
  @progress.Getter getScore

  @progress.Action setProgress
  @progress.Action setScore

  rows: number = 20
  cells: number = 10

  rowIndex: number = -1
  cellIndex: number = 0

  touchIntervalId: any
  gameIntervalId: any

  grid: State[][] = []

  isPause: boolean = true
  hasGameProgress: boolean = false
  isShowGame: boolean = false
  isLandscape: boolean = false

  stat: Stat = {
    score: 0,
    lines: 0,
  }

  color: Color = {
    current: '',
    next: '',
  }

  colors: string[] = ['-green', '-red', '-blue', '-orange']

  block: Block = {
    current: [],
    next: [],
    process: [],
  }

  blocks: number[][][] = [
    [
      [1, 1, 1, 1],
    ],
    [
      [0, 1, 0],
      [1, 1, 1],
    ],
    [
      [1, 1, 0],
      [0, 1, 1],
    ],
    [
      [0, 1, 1],
      [1, 1, 0],
    ],
    [
      [1, 0, 0],
      [1, 1, 1],
    ],
    [
      [0, 0, 1],
      [1, 1, 1],
    ],
    [
      [1, 1],
      [1, 1],
    ],
  ]

  created() {
    const progress = this.getProgress

    if(Object.keys(progress).length) {
      this.hasGameProgress = true
      this.isShowGame = true

      this.stat = progress.stat
      this.block = progress.block
      this.color = progress.color
      this.grid = progress.grid
    }
  }

  mounted() {
    this.bindEvents()
  }

  createGrid(): void {
    this.grid = []

    for(let n = 0; n < this.rows; n++) {
      this.grid.push([])
      for(let i = 0; i < this.cells; i++) {
        this.grid[n].push({
          state: 0,
          color: '',
        })
      }
    }
  }

  onKeyDown(e: KeyboardEvent): void {
    if(!this.isPause) {
      switch(e.keyCode) {
        case 37:
          this.toLeft()
          break
        case 39:
          this.toRight()
          break
        case 40:
          this.toDown()
          break
        case 38:
          this.rotateBlock()
          break
        case 32:
          this.isPause = true
          break
      }
    }
  }

  isFirstStep(): boolean {
    return !this.block.process.length
  }

  go(): boolean {
    const process: [number, number][] = []
    let amountCells: number = 0

    if(this.isFirstStep()) {
      this.cellIndex = Math.floor((this.cells - this.block.current[0].length) / 2)
    }

    this.block.current.forEach((row, n) => {
      row.forEach((cell, i) => {
        if(cell) {
          const realRow = this.rowIndex + n
          const realCell = this.cellIndex + i

          amountCells++

          if(this.grid[realRow] && this.grid[realRow][realCell] && this.grid[realRow][realCell].state !== -1) {
            process.push([realRow, realCell])
          }
        }
      })
    })

    if(amountCells === process.length) {
      this.block.process.forEach(item => this.grid[item[0]][item[1]].state = 0)

      process.forEach(item => {
        this.grid[item[0]][item[1]].color = this.color.current
        this.grid[item[0]][item[1]].state = 1
      })

      this.block.process = process

      return true
    }

    return false
  }

  toDown(): void {
    let lines: number = 0
    this.rowIndex++

    if(!this.go()) {
      if(this.isFirstStep()) {
        this.touchEnd()

        if(this.stat.score) {
          this.setScore(this.stat)
        }

        this.setProgress({})
        this.hasGameProgress = false
        this.isPause = true
        return
      }

      this.block.process.forEach((item: [number, number]) => this.grid[item[0]][item[1]].state = -1)

      this.block.process.forEach((item: [number, number]) => {
        if(this.grid[item[0]] && this.grid[item[0]].filter((cell: any) => cell.state === -1).length === 10) {
          lines++
          this.stat.score += (item[0] + 1) * lines
          this.grid[item[0]].forEach((cell: any) => cell.state = 0)
          this.grid.unshift(this.grid.splice(item[0], 1)[0])
        }
      })

      this.stat.lines += lines

      this.setDefaultOptions()
      this.setProgress({
        stat: this.stat,
        block: this.block,
        color: this.color,
        grid: this.grid,
      })
      this.toDown()
    }
  }

  toLeft(): void {
    this.cellIndex--

    if(!this.go()) {
      this.cellIndex++
    }
  }

  toRight(): void {
    this.cellIndex++

    if(!this.go()) {
      this.cellIndex--
    }
  }

  rotateBlock(): void {
    let prevCellIndex: number
    let prevBlock: number[][]
    let rules: number[][] = []

    if(this.block.process.length) {
      [...this.block.current].reverse().forEach(line => {
        line.forEach((item, n) => {
          if(!rules[n]) {
            rules[n] = []
          }

          rules[n].push(item)
        })
      })

      const cellIndex = (rules.length - this.block.current.length) / 2
      prevCellIndex = this.cellIndex
      prevBlock = this.block.current
      this.cellIndex += cellIndex > 0 ? Math.floor(cellIndex) : Math.ceil(cellIndex)
      this.block.current = rules

      if(!this.go()) {
        this.cellIndex = prevCellIndex || this.cellIndex
        this.block.current = prevBlock || this.block.current
      }
    }
  }

  setDefaultOptions(): void {
    this.block.process = []
    this.rowIndex = -1
    this.cellIndex = 0

    if(!this.color.current || !this.block.current) {
      this.setNextParams()
    }

    this.color.current = this.color.next
    this.block.current = this.block.next

    this.setNextParams()
  }

  setNextParams(): void {
    this.color.next = this.colors[this.getRandomInt(0, this.colors.length)]
    this.block.next = this.blocks[this.getRandomInt(0, this.blocks.length)]
  }

  getRandomInt(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min)) + min
  }

  onClickNewGame(): void {
    this.isPause = false
    this.hasGameProgress = true
    this.isShowGame = true
    this.color.current = ''
    this.stat.score = 0
    this.stat.lines = 0
    this.createGrid()
    this.setDefaultOptions()
    this.$nextTick(this.onResize)
    this.setProgress({})
  }

  onClickResume(): void {
    this.isPause = false
  }

  touchStart(e: TouchEvent, fn: (() => void)): void {
    if(e.touches.length === 1) {
      fn()
      this.touchIntervalId = setInterval(fn, 100)
    }
  }

  touchEnd(): void {
    clearInterval(this.touchIntervalId)
  }

  checkOrientation(): void {
    this.isLandscape = Math.abs(<number>window.orientation) === 90
  }

  onResize(): void {
    const main = this.$refs.main as HTMLElement

    if(main) {
      main.style.width = `${main.offsetHeight / 2}px`
    }
  }

  bindEvents(): void {
    document.addEventListener('keydown', this.onKeyDown)
    window.addEventListener('blur', () => this.isPause = true)

    window.addEventListener('resize', this.onResize)
    this.onResize()

    window.addEventListener('orientationchange', this.checkOrientation)
    this.checkOrientation()
  }

  @Watch('isPause', { immediate: true })
  handler(val: boolean) {
    if(val) {
      clearInterval(this.gameIntervalId)
    } else {
      this.$nextTick(() => this.toDown())
      this.gameIntervalId = setInterval(this.toDown, 500)
    }
  }
}
